export enum UICMasterType {
  CompanyForm = "[AdvinMaster].[uic].[CompanyMaster]",
  CustomerList = "[AdvinMaster].[uiclist].[Customer]",
  CustomerForm = "[AdvinMaster].[uic].[Customer]",
  SubscriptionPlanForm = "[AdvinMaster].[uic].[SubscriptionPlans]",
  SubscriptionPlanList = "[AdvinMaster].[uiclist].[SubscriptionPlans]",
  SubscriptionPlanData = "[AdvinMaster].[sub].[SubscriptionPlansData_ReadAllPaginated]",
  SubscriptionDetailForm = "[AdvinMaster].[uic].[SubscriptionDetails]",
  SubscriptionDetailList = "[AdvinMaster].[uiclist].[SubscriptionDetails]",
  SubscriptionDetailData = "[AdvinMaster].[sub].[SubscriptionDetailsData_ReadAllPaginated]",
  CustomerSubscriptionsForm = "[AdvinMaster].[uic].[CustomerSubscriptions]",
  CustomerSubscriptionsList = "[AdvinMaster].[uiclist].[CustomerSubscriptions]",
  CustomerSubscriptionsData = "[AdvinMaster].[sub].[CustomerSubscriptionsData_ReadAllPaginated]",
  CustomerData = "[ERP].[ERP].[CustomerData_ReadAllPaginated]",
  CustomerDataById = "[ERP].[ERP].[CustomerData_ReadById]",
  SupplierList = "[AdvinMaster].[uiclist].[Supplier]",
  SupplierForm = "[AdvinMaster].[uic].[Supplier]",
  SupplierData = "[ERP].[ERP].[SupplierData_ReadAllPaginated]",
  SupplierDataById = "[ERP].[ERP].[SupplierData_ReadById]",
  VendorList = "[AdvinMaster].[uiclist].[Vendor]",
  VendorForm = "[AdvinMaster].[uic].[Vendor]",
  VendorData = "[ERP].[ERP].[VendorData_ReadAllPaginated]",
  VendorDataById = "[ERP].[ERP].[VendorData_ReadById]",
  EmailList = "[CRM].[uiclist].[EmailMarketingDetail]",
  EmailForm = "[CRM].[uic].[EmailMarketingDetail]",
  EmailData = "[CRM].[crm].[BulkEmailData_ReadAllPaginated]",
  StaffList = "[AdvinMaster].[uiclist].[StaffMaster]",
  StaffForm = "[AdvinMaster].[uic].[StaffMaster]",
  StaffData = "[AdvinMaster].[dbo].[StaffMasterData_ReadAllPaginated]",
  NotifHistoryList = "[AdvinMaster].[uiclist].[NotificationMaster]",
  AccountList = "[ERP].[uiclist].[Accounts]",
  AccountForm = "[ERP].[uic].[Accounts]",
  AccountData = "[ERP].[acc].[AccountsData_ReadAllPaginated]",
  VoucherList = "[ERP].[uiclist].[Vouchers]",
  VoucherForm = "[ERP].[uic].[Vouchers]",
  VoucherData = "[ERP].[acc].[VouchersData_ReadAllPaginated]",
  BankList = "[AdvinMaster].[uiclist].[BankDetail]",
  BankForm = "[AdvinMaster].[uic].[BankDetail]",
  BankData = "[AdvinMaster].[dbo].[ReadAll]",
  BankDataById = "[AdvinMaster].[dbo].[]",
  QuotationMasterList = "[CRM].[uiclist].[QuotationMaster]",
  QuotationMasterForm = "[CRM].[uic].[QuotationMaster]",
  QuotationMasterData = "[CRM].[crm].[QuotationMasterData_ReadAllPaginated]",
  QuotationMasterDetailData = "[CRM].[crm].[QuotationMasterDetailData_ReadAllPaginated]",
  QuotationMasterDetailList = "[CRM].[uiclist].[QuotationMasterDetailView]",
  RevisedQuotationForm = "[CRM].[uic].[RevisedQuotation]",
  QuotationCloneAndCreateForm = "[CRM].[uic].[Quotation_CloneAndCreate]",
  EmailConfigList = "[AdvinMaster].[uiclist].[EmailConfig]",
  EmailConfigForm = "[AdvinMaster].[uic].[EmailConfig]",
  EmailConfigData = "[AdvinMaster].[ann].[EmailConfigData_ReadAllPaginated]",
  QuotationDetailList = "[CRM].[uiclist].[QuotationDetail]",
  QuotationDetailForm = "[CRM].[uic].[QuotationDetail]",
  QuotationDetailData = "[CRM].[crm].[QuotationDetailData_ReadAll]",
  TrialBalanceList = "[ERP].[uiclist].[GetTrialBalanceByGroup]",
  DayBookList = "[ERP].[uiclist].[GetDayBook]",
  BalanceSheetList = "[ERP].[uiclist].[GetBalanceSheet]",
  LedgerReportList = "[ERP].[uiclist].[GetLedgerReport]",
  ProfitLossList = "[ERP].[uiclist].[GetProfitAndLoss]",
  ItemForm = "[ERP].[uic].[ItemMaster]",
  ItemList = "[ERP].[uiclist].[ItemMaster]",
  ItemData = "[ERP].[erp].[ItemData_ReadAllPaginated]",
  SalesForm = "[ERP].[uic].[SalesMaster]",
  SalesList = "[ERP].[uiclist].[SalesMaster]",
  SalesData = "[ERP].[erp].[SalesMasterData_ReadAllPaginated]",
  SalesDetailForm = "[ERP].[uic].[SalesDetail]",
  SalesDetailList = "[ERP].[uiclist].[SalesDetail]",
  SalesDetailData = "[ERP].[erp].[ReadByInvoiceId]",
  PurchaseMasterList = "[ERP].[uiclist].[PurchaseMaster]",
  PurchaseMasterForm = "[ERP].[uic].[PurchaseMaster]",
  PurchaseMasterData = "[ERP].[erp].[PurchaseMasterData_ReadAllPaginated]",
  PurchaseMasterDetailList = "[ERP].[uiclist].[PurchaseMasterDetailView]",
  PurchaseMasterDetailData = "[ERP].[erp].[PurchaseMasterDetailData_ReadAllPaginated]",
  // One row per PurchaseMaster (GRN/invoice) with its item lines nested in an ItemsJson column
  // (FOR JSON PATH) — pages at the invoice level so a GRN's items can never be split across a
  // page boundary, and merges Approved/Rejected split lines for the same item into one row with
  // ApprovedQty/RejectedQty. Used by material-inward-history's 'masterDetail' (default) view mode;
  // PurchaseMasterDetailData above (flat, one row per item) is still used by 'detail' view mode.
  PurchaseMasterDetailWithItemsData = "[ERP].[erp].[PurchaseMasterDetail_ReadAllPaginated]",
  PurchaseDetailList = "[ERP].[uiclist].[PurchaseDetail]",
  PurchaseDetailForm = "[ERP].[uic].[PurchaseDetail]",
  PurchaseDetailVerificationList = "[ERP].[uiclist].[PurchaseDetailVerification]",
  PurchaseDetailVerificationForm = "[ERP].[uic].[PurchaseDetailVerification]",
  SalesReleaseForm = "[ERP].[uic].[SalesRelease]",
  SalesReleaseList = "[ERP].[uiclist].[SalesRelease]",
  SalesReleaseData = "[ERP].[erp].[SalesReleaseData_ReadAllPaginated]",
  SalesReleaseDetailForm = "[ERP].[uic].[SalesReleaseDetail]",
  SalesReleaseDetailList = "[ERP].[uiclist].[SalesReleaseDetail]",
  SalesReleaseDetailData = "[ERP].[erp].[SalesRelease_ReadByReleaseId]",
  PurchaseReleaseForm = "[ERP].[uic].[PurchaseRelease]",
  PurchaseReleaseUicList = "[ERP].[uiclist].[PurchaseRelease]",
  PurchaseReleasePaginatedList = "[ERP].[erp].[PurchaseReleaseData_ReadAllPaginated]",
  PurchaseReleaseDetailForm = "[ERP].[uic].[PurchaseReleaseDetail]",
  PurchaseReleaseDetailList = "[ERP].[uiclist].[PurchaseReleaseDetail]",
  SalesOrderForm = '[ERP].[uic].[SalesOrder]',
  SalesOrderList = '[ERP].[uiclist].[SalesOrder]',
  SalesOrderData = '[ERP].[erp].[SalesOrderData_ReadAllPaginated]',
  SalesOrderDetailForm = '[ERP].[uic].[SalesOrderDetail]',
  SalesOrderDetailList = '[ERP].[uiclist].[SalesOrderDetail]',
  SalesOrderDetailData = '[ERP].[erp].[SalesOrderDetail_ReadAllPaginated]',
  JobWorkOutMasterList = "[ERP].[uiclist].[JobWorkOutMaster]",
  JobWorkOutMasterForm = "[ERP].[uic].[JobWorkOutMaster]",
  JobWorkOutMasterData = "[ERP].[erp].[JobWorkOutMasterData_ReadAllPaginated]",
  JWOOutDetailList = "[ERP].[uiclist].[JWOOutDetail]",
  JWOOutDetailForm = "[ERP].[uic].[JWOOutDetail]",
  JWOInDetailList = "[ERP].[uiclist].[JWOInDetail]",
  JWOInDetailForm = "[ERP].[uic].[JWOInDetail]",
  JWOInDetailData = "[ERP].[erp].[JWOInDetailData_ReadAllPaginated]",
  // ---- Item Planning (ItemPlanningToJobWorker module) ----
  ItemPlanningMasterForm = "[ERP].[uic].[ItemPlanningMaster]",
  ItemPlanningMasterList = "[ERP].[uiclist].[ItemPlanningMaster]",
  ItemPlanningMasterData = "[ERP].[erp].[ItemPlanningMasterData_ReadAllPaginated]",
  ItemProcessPlanningForm = "[ERP].[uic].[ItemProcessPlanning]",
  ItemProcessPlanningList = "[ERP].[uiclist].[ItemProcessPlanning]",
  ItemProcessPlanningData = "[ERP].[erp].[ItemProcessPlanningData_ReadAllPaginated]",
  ItemMaterialPlanningForm = "[ERP].[uic].[ItemMaterialPlanning]",
  ItemMaterialPlanningList = "[ERP].[uiclist].[ItemMaterialPlanning]",
  ItemMaterialPlanningData = "[ERP].[erp].[ItemMaterialPlanningData_ReadAllPaginated]",
  InstructionsForm = "[ERP].[uic].[InstructionsMaster]",
  InstructionsList = "[ERP].[uiclist].[InstructionsMaster]",
  PrintTemplateForm = "[AdvinMaster].[uic].[PrintTemplate]",
  PrintTemplateList = "[AdvinMaster].[uiclist].[PrintTemplate]",
  PrintTemplateReadAllPaginated = "[AdvinMaster].[dbo].[PrintTemplateData_ReadAllPaginated]",
  PortMasterForm = "[AdvinMaster].[uic].[PortMaster]",
  PortMasterList = "[AdvinMaster].[uiclist].[PortMaster]",
  PortMasterData = "[AdvinMaster].[dbo].[PortMasterData_ReadAllPaginated]",
  InventoryData = "[ERP].[report].[ItemMasterInventory]",
  InventoryList = "[ERP].[uiclist].[InventoryReport]",
  DepotForm ="[ERP].[uic].[Depot]",
  DepotList = "[ERP].[uiclist].[Depot]",
  DepotData = "[ERP].[erp].[DepotData_ReadAllPaginated]",
  LabelMasterForm = "[ERP].[uic].[LabelMaster]",
  LabelMasterList = "[ERP].[uiclist].[LabelMaster]",
  LabelMasterData = "[ERP].[erp].[LabelMasterData_ReadAllPaginated]",
  LabelDetailForm = "[ERP].[uic].[LabelDetail]",
  LabelDetailList = "[ERP].[uiclist].[LabelDetail]",
  LabelDetailData = "[ERP].[erp].[LabelDetailData_ReadAllPaginated]",
  SiteMasterForm = "[CRM].[uic].[SiteMaster]", 
  SiteMasterData = "[CRM].[CRM].[SiteMasterData_ReadAllPaginated]", 
  SiteMasterList = "[CRM].[uiclist].[SiteMaster]",
  TerritoryMasterForm = "[CRM].[uic].[TerritoryMaster]",
  TerritoryMasterList = "[CRM].[uiclist].[TerritoryMaster]",
  TerritoryMasterData = "[CRM].[crm].[TerritoryMaster_ReadAllPaginated]",
  TerritoryAreaForm = "[CRM].[uic].[TerritoryArea]",
  TerritoryAreaList = "[CRM].[uiclist].[TerritoryArea]",
  TerritoryAreaData = "[CRM].[crm].[TerritoryArea_ReadAllPaginated]",
  tableForm = "[ERP].[uic].[HotelTableMaster]",
  tableList = "[ERP].[uiclist].[HotelTableMaster]",
  tableData = "[ERP].[ERP].[HotelTableMasterData_ReadAllPaginated]",
  ReceiptData = "[ERP].[erp].[ReceiptMasterData_ReadAllPaginated]",
  ReceiptForm = "[ERP].[uic].[ReceiptMaster]",
  ReceiptList = "[ERP].[uiclist].[ReceiptMaster]",
  ReceiptDetailForm = "[ERP].[uic].[ReceiptDetail]",
  ReceiptDetailList= "[ERP].[uiclist].[ReceiptDetail]",
  ReceitDetailData = "[ERP].[erp].[ReceiptDetailData_ReadAllPaginated]",
  DriverMasterForm = "[ERP].[uic].[DriverMaster]",
  DriverMasterList = "[ERP].[uiclist].[DriverMaster]",
  DriverMasterData = "[ERP].[erp].[DriverMasterData_ReadAllPaginated]",
  BrokerMasterForm = "[ERP].[uic].[BrokerMaster]",
  BrokerMasterList = "[ERP].[uiclist].[BrokerMaster]",
  BrokerMasterData = "[ERP].[erp].[BrokerMasterData_ReadAllPaginated]",
  ConsignmentForm = "[ERP].[uic].[Consignment]",
  ConsignmentList = "[ERP].[uiclist].[Consignment]",
  ConsignmentData = "[ERP].[erp].[ConsignmentData_ReadAllPaginated]",
  ItemMasterBulkForm = "[ERP].[uicbulk].[ItemMaster]",
  CustomerBulkForm = "[AdvinMaster].[uicbulk].[Customer]",
  SupplierBulkForm = "[AdvinMaster].[uicbulk].[Supplier]",
  MSItemsData = "[ERP].[erp].[MSItemMasterData_ReadAllPaginated]",
  MSItemsForm = "[ERP].[uic].[MSItemMaster]",
  MSItemsList = "[ERP].[uiclist].[MSItemMaster]",
  DestinationMasterForm = "[ERP].[uic].[DestinationMaster]",
  DestinationMasterList = "[ERP].[uiclist].[DestinationMaster]",
  DestinationMasterData = "[ERP].[erp].[DestinationMasterData_ReadAllPaginated]",
  LabelDesignData = "[AdvinMaster].[dbo].[LabelDesignData_ReadAllPaginated]",
  LabelDesignForm = "[AdvinMaster].[uic].[LabelDesign]",
  LabelDesignList = "[AdvinMaster].[uiclist].[LabelDesign]",
  SupportTicketsData = "[SupportDesk].[spd].[SupportTicketsData_ReadAllPaginated]",
  SupportTicketsForm = "[SupportDesk].[uic].[SupportTickets]",
  SupportTicketsList = "[SupportDesk].[uiclist].[SupportTickets]",
  LeadmasterData = "[CRM].[crm].[LeadMaster_ReadAllPaginated]",
  LeadmasterForm = "[CRM].[uic].[LeadMaster]",
  LeadmasterList = "[CRM].[uiclist].[LeadMaster]",
  LeadDetailForm = "[CRM].[uic].[LeadDetail]",
  LeadDetailList = "[CRM].[uiclist].[LeadDetail]",
  LeadDetailData = "[CRM].[crm].[LeadDetailData_ReadAllPaginated]",
  ConsigneeForm = "[ERP].[uic].[Consignee]",
  ConsigneeList = "[ERP].[uiclist].[Consignee]",
  ConsigneeData = "[ERP].[erp].[ConsigneeData_ReadAllPaginated]",
  BillingPartyForm = "[ERP].[uic].[BillingParty]",
  TrafficPersonForm = "[ERP].[uic].[TrafficPerson]",
  VehicleMasterForm = "[ERP].[uic].[VehicleMaster]",
  VehicleMasterList = "[ERP].[uiclist].[VehicleMaster]",
  VehicleMasterData = "[ERP].[erp].[VehicleMasterData_ReadAllPaginated]",
  DocMasterForm = "[AdvinMaster].[uic].[DocMaster]",
  DocMasterList = "[AdvinMaster].[uiclist].[DocMaster]",
  BranchForm = "[AdvinMaster].[uic].[BranchMaster]",
  BranchList = "[AdvinMaster].[uiclist].[BranchMaster]",
  BranchData = "[AdvinMaster].[dbo].[BranchMasterData_ReadAllPaginated]",
  ProjectMasterForm = "[PMS].[uic].[ProjectMaster]",
  ProjectMasterList = "[PMS].[uicList].[ProjectMaster]",
  ProjectMasterData = "[PMS].[PMS].[ProjectMasterData_ReadAllPaginated]",
  PMSTemplateMasterForm = "[PMS].[uic].[TemplateMaster]",
  PMSTemplateMasterList = "[PMS].[uicList].[TemplateMaster]",
  PMSTemplateMasterData = "[PMS].[PMS].[TemplateMasterData_ReadAllPaginated]",
  PMSTemplateDetailList = "[PMS].[uiclist].[TemplateDetail]",
  PurchaseChallanForm = "[ERP].[uic].[PurchaseChallan]",
  PurchaseChallanList = "[ERP].[uiclist].[PurchaseChallan]",
  PurchaseChallanData = "[ERP].[erp].[PurchaseChallanData_ReadAllPaginated]",
  SalesChallanForm = "[ERP].[uic].[SalesChallan]",
  SalesChallanList = "[ERP].[uiclist].[SalesChallan]",
  SalesChallanData = "[ERP].[erp].[SalesChallanData_ReadAllPaginated]",

  SalesChallanDetailForm = "[ERP].[uic].[SalesChallanDetail]",
  SalesChallanDetailList = "[ERP].[uiclist].[SalesChallanDetail]",
  SalesChallanDetailData = "[ERP].[erp].[SalesChallanDetail_ReadAllPaginated]",


  ItemStockForm = "[ERP].[uic].[ItemStock]",
  ItemStockList = "[ERP].[uiclist].[ItemStock]",
  ItemStockData = "[ERP].[erp].[ItemStockData_ReadAllPaginated]",
  ServiceMasterForm = "[ERP].[uic].[ServiceMaster]",
  ServiceMasterList = "[ERP].[uiclist].[ServiceMaster]",
  ServiceMasterkData = "[ERP].[erp].[ServiceMasterData_ReadAllPaginated]",
  CreditNoteMasterForm = "[ERP].[uic].[CreditNoteMaster]",
  CreditNoteMasterList = "[ERP].[uiclist].[CreditNoteMaster]",
  CreditNoteMasterkData = "[ERP].[erp].[CreditNoteMasterData_ReadAllPaginated]",
  DebitNoteMasterForm = "[ERP].[uic].[DebitNoteMaster]",
  DebitNoteMasterList = "[ERP].[uiclist].[DebitNoteMaster]",
  DebitNoteMasterkData = "[ERP].[erp].[DebitNoteMasterData_ReadAllPaginated]",
  ItemDetailDatalistForm = "[ERP].[uic].[ItemDetailDatalist]",
  ItemDetailDatalistList = "[ERP].[uiclist].[ItemDetailDatalist]",
  ItemDetailDatalistkData = "[ERP].[erp].[ItemDetailDatalistData_ReadAllPaginated]",
  CreditNoteDetailForm = "[ERP].[uic].[CreditNoteDetail]",
  CreditNoteDetailList = "[ERP].[uiclist].[CreditNoteDetail]",
  CreditNoteDetailData = "[ERP].[erp].[CreditNoteDetail_ReadAllPaginated]",
  DebitNoteDetailForm = "[ERP].[uic].[DebitNoteDetail]",
  DebitNoteDetailList = "[ERP].[uiclist].[DebitNoteDetail]",
  DebitNoteDetailData = "[ERP].[erp].[DebitNoteDetail_ReadAllPaginated]",
  CreditNoteChallanForm = "[ERP].[uic].[CreditNoteChallan]",
  CreditNoteChallanList = "[ERP].[uiclist].[CreditNoteChallan]",
  CreditNoteChallanData = "[ERP].[erp].[CreditNoteChallanData_ReadAllPaginated]",
  DebitNoteChallanForm = "[ERP].[uic].[DebitNoteChallan]",
  DebitNoteChallanList = "[ERP].[uiclist].[DebitNoteChallan]",
  DebitNoteChallanData = "[ERP].[erp].[DebitNoteChallanData_ReadAllPaginated]",
  PaymentMasterForm ="[ERP].[uic].[PaymentMaster]",
  PaymentMasterList="[ERP].[uiclist].[PaymentMaster]",
  PaymentMasterData="[ERP].[erp].[PaymentMasterData_ReadAllPaginated]",
  PaymentDetailForm ="[ERP].[uic].[PaymentDetail]",
  PaymentDetailList ="[ERP].[uiclist].[PaymentDetail]",
  PaymentDetailData ="[ERP].[erp].[PaymentDetailData_ReadAllPaginated]",
  JobWorkInMasterForm="[ERP].[uic].[JobWorkInMaster]",
  JobWorkInMasterList="[ERP].[uiclist].[JobWorkInMaster]",
  JobWorkInMasterData="[ERP].[erp].[JobWorkInMasterData_ReadAllPaginated]",
  JobWorkInDetailForm = "[ERP].[uic].[JobWorkInDetail]",
  JobWorkInDetailList = "[ERP].[uiclist].[JobWorkInDetail]",
  JobWorkInDetailData = "[ERP].[erp].[JobWorkInDetailData_ReadAllPaginated]",
  IndentMasterForm = "[ERP].[uic].[PurIndentMaster]",
  IndentMasterList = "[ERP].[uiclist].[PurIndentMaster]",
  IndentMasterData = "[ERP].[erp].[PurIndentMasterData_ReadAllPaginated]",
  IndentDetailForm = "[ERP].[uic].[PurIndentDetail]",
  IndentDetailList = "[ERP].[uiclist].[PurIndentDetail]",
  IndentDetailData = "[ERP].[erp].[PurIndentDetailData_ReadAllPaginated]",
  PurIndentMasterDetailViewList = "[ERP].[uicList].[PurIndentMasterDetailView]",
  AmcMasterForm ="[ERP].[uic].[AmcMaster]",
  AmcMasterList = "[ERP].[uiclist].[AmcMaster]",
  AmcMasterData = "[ERP].[erp].[AmcMasterData_ReadAllPaginated]",
  AmcDetailForm ="[ERP].[uic].[AmcDetail]",
  AmcDetailList = "[ERP].[uiclist].[AmcDetail]",
  AmcDetailData = "[ERP].[erp].[AmcDetailData_ReadAllPaginated]",
  ItemVendorPriceForm ="[ERP].[uic].[ItemVendorPrice]",
  ItemVendorPriceList ="[ERP].[uiclist].[ItemVendorPrice]",
  ItemVendorPriceData ="[ERP].[erp].[ItemVendorPriceData_ReadAllPaginated]",
  PurchaseOrderForm = "[ERP].[uic].[PurchaseOrder]",
  PurchaseOrderList = "[ERP].[uiclist].[PurchaseOrder]",
  PurchaseOrderDetailForm = "[ERP].[uic].[PurchaseOrderDetail]",
  PurchaseOrderDetailList = "[ERP].[uiclist].[PurchaseOrderDetail]",
  PurchaseOrderVerificationList = "[ERP].[uiclist].[PurchaseOrderVerification]",
  PurchaseOrderVerificationData = "[ERP].[erp].[PurchaseOrderVerificationData_ReadAllPaginated]",
  PurchaseOrderData = "[ERP].[erp].[PurchaseOrderData_ReadAllPaginated]",
  PurchaseOrderDetailView = "[Erp].[uiclist].[PurchaseOrderDetailView]",
  PurchaseOrderDetailData = "[ERP].[erp].[PurchaseOrderDetailData_ReadAllPaginated]",
  DepartmentData = "[HRMS].[hrms].[Departments_ReadAllPaginated]",
  DepartmentForm = "[HRMS].[uic].[Departments]",
  DepartmentList = "[HRMS].[uiclist].[Departments]",
  DesignationData = "[HRMS].[hrms].[Designations_ReadAllPaginated]",
  DesignationForm = "[HRMS].[uic].[Designations]",
  DesignationList = "[HRMS].[uiclist].[Designations]",
  EmployeeShiftMappingData = "[HRMS].[hrms].[EmployeeShiftMappingData_ReadAllPaginated]",
  EmployeeShiftMappingList = "[HRMS].[uiclist].[EmployeeShiftMapping]",
  DocMasterReadAllPaginated = "[AdvinMaster].[dbo].[DocMaster_ReadAllPaginated]",
  PurchaseOrder_OutstandingList = "[erp].[uiclist].[PurchaseOrder_OutstandingReport]",
  PurchaseOrder_OutstandingData = "[erp].[report].[PurchaseOrder_OutstandingReport]",
  storageForm = "[ERP].[uic].[StorageMaster]",
  StorageList = "[ERP].[uiclist].[StorageMaster]",
  AddressDetailForm = "[AdvinMaster].[uic].[AddressDetail]",
  AddressDetailList = "[AdvinMaster].[uiclist].[AddressDetail]",
  AddressDetailData = "[AdvinMaster].[dbo].[AddressDetailData_ReadAllPaginated]",
  AmcPendingList = "[ERP].[uiclist].[AmcPending]",
  AmcPendingData = "[ERP].[erp].[AmcPendingData_ReadAllPaginated]",
  TransportList = "[AdvinMaster].[uiclist].[Transport]",
  TransportForm = "[AdvinMaster].[uic].[Transport]",
  TransportData = "[ERP].[ERP].[TransportData_ReadAllPaginated]",
  AgencyList = "[AdvinMaster].[uiclist].[Agency]",
  AgencyForm = "[AdvinMaster].[uic].[Agency]",
  AgencyData = "[ERP].[ERP].[AgencyData_ReadAllPaginated]",
  VendorDefaultOtherChargesForm = "[ERP].[uic].[VendorDefaultOtherCharges]",
  VendorDefaultOtherChargesList = "[ERP].[uiclist].[VendorDefaultOtherCharges]",
  PackageMasterForm = "[HRMS].[uic].[PackageMaster]",
  PackageMasterList = "[HRMS].[uiclist].[PackageMaster]",
  PackageMasterData = "[HRMS].[payroll].[PackageMasterData_ReadAllPaginated]",
  PackageDetailForm = "[HRMS].[uic].[PackageDetail]",
  PackageDetailList = "[HRMS].[uiclist].[PackageDetail]",
  PackageDetailData = "[HRMS].[payroll].[PackageDetailData_ReadAllPaginated]",
  ComponentForm = "[HRMS].[uic].[Component]",
  ComponentList = "[HRMS].[uiclist].[Component]",
  ComponentData = "[HRMS].[payroll].[ComponentData_ReadAllPaginated]",
  IndentVerificationMasterForm = "[ERP].[uic].[PurIndentVerificationMaster]",
  IndentVerificationDetailForm = "[ERP].[uic].[PurIndentVerificationDetail]",
  SalesIndentMasterForm = "[ERP].[uic].[SalesIndentMaster]",
  SalesIndentMasterList = "[ERP].[uiclist].[SalesIndentMaster]",
  SalesIndentMasterData = "[ERP].[erp].[SalesIndentMasterData_ReadAllPaginated]",
  SalesIndentDetailForm = "[ERP].[uic].[SalesIndentDetail]",
  SalesIndentDetailList = "[ERP].[uiclist].[SalesIndentDetail]",
  SalesIndentDetailData = "[ERP].[erp].[SalesIndentDetailData_ReadAllPaginated]",
  SalesIndentVerificationMasterList = "[ERP].[uiclist].[SalesIndentVerificationMaster]",
  EInvoiceList = "[ERP].[uiclist].[EInvoiceMaster]",
  EInvoiceListData = "[ERP].[eway].[EInvoiceMasterData_ReadAllPaginated]",
  ProductServiceMappingForm = "[ERP].[uic].[ProductServiceMapping]",
  ProductServiceMappingList = "[ERP].[uiclist].[ProductServiceMapping]",
  ProductServiceMappingData = "[ERP].[erp].[ProductServiceMappingData_ReadAllPaginated]",
  RawMaterialForm = "[ERP].[uic].[RawMaterialMaster]",
  RawMaterialList = "[ERP].[uiclist].[RawMaterialMaster]",
  RawMaterialData = "[ERP].[erp].[RawMaterialData_ReadAllPaginated]",
  SemiFinishedGoodsForm = "[ERP].[uic].[SemiFinishedGoods]",
  SemiFinishedGoodsList = "[ERP].[uiclist].[SemiFinishedGoods]",
  SemiFinishedGoodsData = "[ERP].[erp].[SemiFinishedGoodsData_ReadAllPaginated]",
  SalesOrderVerificationMasterList = "[ERP].[uiclist].[SalesOrderVerificationMaster]",
  GenericImport_Quotation = "[CRM].[uic].[GenericImport_Quotation]",
  GenericImport_SalesIndent = "[ERP].[uic].[GenericImport_SalesIndent]",
  GenericImport_SalesOrder = "[ERP].[uic].[GenericImport_SalesOrder]",
  GenericImport_SalesChallan = "[ERP].[uic].[GenericImport_SalesChallan]",
  GenericImport_SalesRelease = "[ERP].[uic].[GenericImport_SalesRelease]",
  GenericImport_SalesInvoice = "[ERP].[uic].[GenericImport_SalesInvoice]",
  GenericImport_PurchaseIndent = "[ERP].[uic].[GenericImport_PurchaseIndent]",
  GenericImport_PurchaseOrder = "[ERP].[uic].[GenericImport_PurchaseOrder]",
  GenericImport_PurchaseChallan = "[ERP].[uic].[GenericImport_PurchaseChallan]",
  GenericImport_PurchaseRelease = "[ERP].[uic].[GenericImport_PurchaseRelease]",
  GenericImport_PurchaseInvoice = "[ERP].[uic].[GenericImport_PurchaseInvoice]",
  GenericImport_CreditNote = "[ERP].[uic].[GenericImport_CreditNote]",
  GenericImport_DebitNote = "[ERP].[uic].[GenericImport_DebitNote]",
  ItemDetailDataForm = "[ERP].[uic].[ItemDetailDatalist]",
  ItemDetailDataList = "[ERP].[uiclist].[ItemDetailDatalist]",
}


// interface aaa{
//   form:string,
//   list:string,
//   data:string
// }

// interface aaaa{
  
// }

// export const abc {
//   Item: {
//     form = "[ERP].[uic].[ItemMaster]",
//     list = "[ERP].[uiclist].[ItemMaster]",
//     data = "[ERP].[uiclist].[ItemMaster]"
//   }
// }